export const SIGN_IN = '/sign-in';
export const PUBLIC_INSPECTION_SHARE = `/share/\${token}`;
export const PLATFORM_ADMIN_HOME = '/platform-admin';
export const INSPECTION_LISTING = '/inspections';
